/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$(document).ready(function() {
    $('#gift_check').change(function() {
        if(this.checked) {
          $('.gift_notes').show();
        }else{
          $('.gift_notes').hide();
        }     
    });
});
